// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2RqsL","content":"GlobalSearch_content__2EfVn"};